<template>
  <v-img class="scene" src="@/assets/scene.png">

  </v-img>
</template>

<script>
export default {
  name: 'World'
}
</script>

<style scoped>
.scene {
  height: 100%;
  overflow-y: hidden;
  position: relative;
  left: 0;
}
</style>
